import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { logout } from "../../features/user";
import axios from "axios";
import { API_URL, API_OK, ACTION_ADD, ACTION_EDIT, CALL_TYPE_IN, CALL_TYPE_OUT, STATUS_BLOCKED, STATUS_OPEN, API_EXCEPTION, DEFAULT_ERROR_TEXT, ALL, CALL_TYPE_ALL, CUSTOMER_VIEW_CUSTOMER} from '../../Constants';
import { FormControlLabel, Backdrop, CircularProgress} from '@mui/material';
import {Button, Select, MenuItem, FormControl, InputLabel, Dialog} from '@mui/material';
import Switch from '@mui/material/Switch';
import '../../styles.css';
import cookie from "js-cookie";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import { showErrorDialog } from "../../features/errorDialog";
import {handleApiErrorMessage, allowedBlockStatuses, allowedBlockCallTypes} from "../../Helper";
import BlockCategoryDesktop from "../Customer/Desktop/BlockCategory";
import BlockCategoryMobile from "../Customer/Mobile/BlockCategory";
import BlockNumberNotes from "../BlockNumberNotes";


export default function BlockCategory(props) {
  const { t } = useTranslation();
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [deleteDialogIsOpen, setDeleteDialogIsOpen] = useState(false);
  const [phoneErrorText, setPhoneErrorText] = useState("");

  const initalSelectedCategoryValue = {
    id: null,
    name: null,
    note: null,
    public: 1,
    privacy_level: 0,
    isOwner: 1,
    myJoin: 0,
    valid: 0,
    active_setting: 0
  };
  const [selectedCategory, setSelectedCategory] = useState(initalSelectedCategoryValue);
  const [selectedCustomer, setSelectedCustomer] = useState(props.customer);
  const [linesInCustomer, setLinesInCustomer] = useState([]);

  const initialLine = {
    id: null,
    number: "",
    use_name: ""
  };
  const [isLinesListVisible, setIsLinesListVisible] = useState(false);
  const [lineToDelete, setLineToDelete] = useState(initialLine);

  const initialLineFormInput = {
    title: t("Add new number"),
    id : null,
    number : "",
    active: 1,
    note: "",
    actionNote: "",
    action: ACTION_ADD,
    // ברירות מחדל נבחרות מתוך המותר במדיניות החסימה של הקהילה.
    call_type: allowedBlockCallTypes().includes(CALL_TYPE_OUT) ? CALL_TYPE_OUT : allowedBlockCallTypes()[0],
    status: allowedBlockStatuses().includes(STATUS_BLOCKED) ? STATUS_BLOCKED : allowedBlockStatuses()[0]
  };
  const [lineFormInput, setLineFormInput] = useState(initialLineFormInput);
  // הערת ביצוע אופציונלית למחיקה (נרשמת ב-block_list_log.action_note)
  const [deleteActionNote, setDeleteActionNote] = useState("");

  const initialSearchInput = {
    number : "",
    active: ALL,
    call_type: ALL,
    status: ALL
  };
  const [searchInput, setSearchInput] = useState(initialSearchInput);

  const [dialogLoaderVisible, setDialogLoaderVisible] = useState(false);
  const [selectionIds, setSelectionIds] = useState(false);
  const [expandedRowIds, setExpandedRowIds] = useState([]);
  
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const defaultSuccessMessage = t("The operation was successfull");

  const [successMessage, setSuccessMessage] = useState(defaultSuccessMessage);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [pageSize, setPageSize] = useState(20000);

  const dispatch = useDispatch();
  const navigate = useNavigate();


  useEffect(() => {
    if(loading){
      return () => {};
    }

    if(props.hasOwnProperty("category")
      && props.category.hasOwnProperty("id")
      && Number.isInteger(props.category.id)){
        const selectedCategoryValueFromProps = {
          id: props.category.id,
          name: props.category.name,
          note: props.category.note,
          public: props.category.public,
          isOwner: props.category.isOwner,
          myJoin: props.category.myJoin,
          valid: props.category.valid,
          privacy_level: props.category.privacy_level
        };
    
        setSelectedCategory(selectedCategoryValueFromProps);
    }
    
  }, []);

  useEffect(() => {
    document.body.addEventListener('click', (e) => {
        if(e.target.closest(".body") !== null 
        || e.target.closest(".header") !== null
        || e.target.closest(".expansions-wrapper") !== null
        ){
        return;
      }else{
        setExpandedRowIds([]);
      }
    })
  }, []);

  useEffect(() => {
    if(loading){
      return () => {};
    }
    if(!Number.isInteger(selectedCategory.id)
      && !Number.isInteger(selectedCustomer.id)
    ){
      return () => {};
    }
    const requestSource = refreshBlockedData(); 
    return () => {
      requestSource.cancel();
    };
  }, [page, pageSize]);

  useEffect(() => {
    if(!Number.isInteger(selectedCategory.id)
      && !Number.isInteger(selectedCustomer.id)
    ){
      return () => {};
    }
    const blockedDataRequestSource = refreshBlockedData(); 
    const linesRequestSource = refreshLinesData();
    
    return () => {
      blockedDataRequestSource.cancel();
      linesRequestSource.cancel();
    };
  }, [selectedCategory.id, selectedCustomer.id, searchInput, props.selectedLine.id]);


  const refreshLinesData = () => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);
    setLoading(true);
    setDialogLoaderVisible(true);

    let  headers = {
      token: cookie.get('token')
    }

    const requestSource = axios.CancelToken.source();
    headers.cancelToken = requestSource.token;

    // picker (not a paged list): load the customer's lines to populate the line selector.
    // a customer has at most a handful of lines, so a generous single-page cap is enough.
    axios.post(API_URL + '/getLinesInCustomers',
    {
      customer_id: props.customer.id,
      start: 0,
      limit: 1000
    },
    {headers}
    ).then(
      ({ data }) => {
        if(data.hasOwnProperty("responseStatus") && (data["responseStatus"] === API_OK && data.hasOwnProperty("lines"))){
          setLinesInCustomer(data.lines);
          setLoading(false);
          resetDialogHideLoader();
        }else{
          if((data.responseStatus === API_EXCEPTION) && (data.hasOwnProperty("message"))){
            errorMessage = data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          setLoading(false);
          setDialogLoaderVisible(false);
        }
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        setLoading(false);
        setDialogLoaderVisible(false);
    });


    return requestSource;
  };


    const refreshBlockedData = (pageToStart = null) => {
      if(pageToStart === null){
        pageToStart = page;
      }
      let errorMessage = t(DEFAULT_ERROR_TEXT);
      setLoading(true);

      let  headers = {
        token: cookie.get('token')
      }

      let apiUrl = API_URL + '/getBlockList';
      if(Number.isInteger(selectedCategory.id)
          && (selectedCategory.id > 0)){
            apiUrl = API_URL + '/categories/'+selectedCategory.id+'/getBlockList';
      }else{
        if(Number.isInteger(selectedCustomer.id)
        && (selectedCustomer.id > 0)){
            apiUrl = API_URL + '/by_customer/'+selectedCustomer.id+'/getBlockList';

            if(Number.isInteger(props.selectedLine.id)
              && (props.selectedLine.id > 0)){
                  apiUrl = API_URL + '/by_line/'+selectedCustomer.id+'/'+props.selectedLine.id+'/getBlockList';
            }
        }
      }

      const requestSource = axios.CancelToken.source();
      headers.cancelToken = requestSource.token;

      axios.post(
        apiUrl, 
        {searchStr: searchInput.number, active: searchInput.active === ALL ? ALL : Number(searchInput.active), status: searchInput.status, call_type: searchInput.call_type, start: pageToStart*pageSize, limit: pageSize}, 
        {headers})
      .then(
        ({ data }) => {
          if(data.hasOwnProperty("responseStatus") && (data["responseStatus"] === API_OK && data.hasOwnProperty("results") && data.hasOwnProperty("totalBlocks"))){
            setRows(data.results);
            setRowCount(data.totalBlocks);
            setLoading(false);
          }else{
            if((data.responseStatus === API_EXCEPTION) && (data.hasOwnProperty("message"))){
              errorMessage = data["message"];
            }
            handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
            setLoading(false);
          }
        }).catch((error) => {
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          setLoading(false);
      });


      return requestSource;
    };

  const handleAddRow = () => {
    setLineFormInput(lineFormInput);
    setDialogIsOpen(true);
  };

  const deleteRows = async (rowIds) => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);

    setDialogLoaderVisible(true);

    let  headers = {
      token: cookie.get('token')
    }

    const data = {
      blockIds: rowIds,
      actionNote: deleteActionNote
    };

    let apiUrl = API_URL + '/deleteBlocks';
    if(Number.isInteger(selectedCategory.id)
        && (selectedCategory.id > 0)){
          apiUrl = API_URL + '/categories/'+selectedCategory.id+'/deleteBlocks';
    }else{
      if(Number.isInteger(selectedCustomer.id)
      && (selectedCustomer.id > 0)){
          apiUrl = API_URL + '/by_customer/'+selectedCustomer.id+'/deleteBlocks';

          if(Number.isInteger(props.selectedLine.id)
            && (props.selectedLine.id > 0)){
                apiUrl = API_URL + '/by_line/'+selectedCustomer.id+'/'+props.selectedLine.id+'/deleteBlocks';
          }
      }
    }

    axios.post(apiUrl, data, {headers})
    .then(
        (responseData) => {
        if(responseData.data.hasOwnProperty('responseStatus') && responseData.data.responseStatus === API_OK){
          refreshBlockedData();
        }else{
          if(responseData.data.responseStatus === API_EXCEPTION && responseData.data.hasOwnProperty("message")){
            errorMessage = responseData.data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        }
        resetDialogHideLoader();
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);

        resetDialogHideLoader();
    });
  };

  const handleDeleteRow = async (row) => {
    deleteRows([row.id]);
  };
  
  const handleDeleteRows = async () => {
    if(!selectionIds){
      alert(t('No lines selected'));
      return;
    }else{
      let nonRemovedRows = rows.filter((row) => (!selectionIds.includes(row.id)));
      if(nonRemovedRows.length === rows.length){
        alert(t('No lines selected'));
        return;
      }
    }
  
    deleteRows(selectionIds);
  };

  const getLineDataIndexById = (lineDataId) => {
    let lineDataIndex = -1;
    for (let index = 0; index < rows.length; index++) {
      const lineData = rows[index];
      if(lineData.id === lineDataId){
        lineDataIndex = index;
        break;
      }
    }
    return lineDataIndex;
  };

  const resetDialogHideLoader = () => {
    setDialogLoaderVisible(false);
    setDialogIsOpen(false);
    setLineFormInput(initialLineFormInput);
  };

  const displaySuccessMessage = (successMessage = null) => {
    if(successMessage != null){
      setSuccessMessage(successMessage);
    }else{
      setSuccessMessage(defaultSuccessMessage);
    }
    
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 2000);
  };

  const addLinesData = (linesDataToAdd) => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);

    let  headers = {
      token: cookie.get('token')
    }

    let apiUrl = API_URL + '/addBlockList';
    if(Number.isInteger(selectedCategory.id)
        && (selectedCategory.id > 0)){
          apiUrl = API_URL + '/categories/'+selectedCategory.id+'/addBlockList';
    }else{
      if(Number.isInteger(selectedCustomer.id)
      && (selectedCustomer.id > 0)){
          apiUrl = API_URL + '/by_customer/'+selectedCustomer.id+'/addBlockList';

          if(Number.isInteger(props.selectedLine.id)
            && (props.selectedLine.id > 0)){
                apiUrl = API_URL + '/by_line/'+selectedCustomer.id+'/'+props.selectedLine.id+'/addBlockList';
          }
      }
    }

    axios.post(apiUrl, linesDataToAdd, {headers})
    .then(
      async (responseData) => {
        if(responseData.data.hasOwnProperty('responseStatus') && responseData.data.responseStatus === API_OK){
          await refreshBlockedData();
          resetDialogHideLoader();
          displaySuccessMessage();
          setShowSuccessMessage(true);
        }else{
          if((responseData.data.responseStatus === API_EXCEPTION) && (responseData.data.hasOwnProperty("message"))){
            errorMessage = responseData.data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          setDialogLoaderVisible(false);
        }
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        setDialogLoaderVisible(false);
    });
  };


  const createCategory = (categoryData) => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);

    let  headers = {
      token: cookie.get('token')
    }

    let apiUrl = API_URL + '/categories/create';

    axios.post(apiUrl, {new_obj: categoryData}, {headers})
    .then(
      async (responseData) => {
        if(responseData.data.hasOwnProperty('responseStatus') && responseData.data.responseStatus === API_OK && responseData.data.hasOwnProperty('newCategorieId')){
          let selectedCategoryData = {
            id: responseData.data.newCategorieId,
            name: selectedCategory.name,
            note: selectedCategory.note,
            public: selectedCategory.public,
            isOwner: selectedCategory.isOwner,
            myJoin: selectedCategory.myJoin
          };
          setSelectedCategory(selectedCategoryData);
          resetDialogHideLoader();
        }else{
          if((responseData.data.responseStatus === API_EXCEPTION) && (responseData.data.hasOwnProperty("message"))){
            errorMessage = responseData.data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          setDialogLoaderVisible(false);
        }
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        setDialogLoaderVisible(false);
    });
  };

  const handleAddBlockSubmit = () => {
    setDialogLoaderVisible(true);
      
    const data = {
      numbers: [
        {
          number: lineFormInput.number,
          active: lineFormInput.active,
          note: lineFormInput.note,
          call_type: lineFormInput.call_type,
          status: lineFormInput.status
        }
      ],
      // הערת הביצוע (actionNote) נרשמת ב-block_list_log.action_note
      actionNote: lineFormInput.actionNote
    };

    addLinesData(data);
  }

  const handleEditBlockSubmit = (blockData) => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);

    setDialogLoaderVisible(true);

    let  headers = {
      token: cookie.get('token')
    }
    
    const data = {
      blockId: blockData.id,
      newData: {
        note: blockData.note,
        active: blockData.active,
        call_type: blockData.call_type,
        status: blockData.status
      },
      // הערת הביצוע (actionNote) נרשמת ב-block_list_log.action_note
      actionNote: blockData.actionNote
    };

    let apiUrl = API_URL + '/editBlock';
    if(Number.isInteger(selectedCategory.id)
        && (selectedCategory.id > 0)){
          apiUrl = API_URL + '/categories/'+selectedCategory.id+'/editBlock';
    }else{
      if(Number.isInteger(selectedCustomer.id)
      && (selectedCustomer.id > 0)){
          apiUrl = API_URL + '/by_customer/'+selectedCustomer.id+'/editBlock';

          if(Number.isInteger(props.selectedLine.id)
            && (props.selectedLine.id > 0)){
                apiUrl = API_URL + '/by_line/'+selectedCustomer.id+'/'+props.selectedLine.id+'/editBlock';
          }
      }
    }

    axios.post(apiUrl, data, {headers})
    .then(
      async (responseData) => {
        if(responseData.data.hasOwnProperty('responseStatus') && responseData.data.responseStatus === API_OK){
          await refreshBlockedData();
          displaySuccessMessage();
        }else{
          if(responseData.data.responseStatus === API_EXCEPTION && responseData.data.hasOwnProperty("message")){
            errorMessage = responseData.data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        }
        resetDialogHideLoader();
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        resetDialogHideLoader();
    });
  }

  const handleDialogClose = () => {
    setDialogIsOpen(false);
  };
  const handleDeleteDialogClose = () => {
    setDeleteDialogIsOpen(false);
    setDeleteActionNote("");
  };

  const changeSearchFilters = (e, fieldName) => {
    let newSearchInput = {
      number : searchInput.number,
      active: searchInput.active,
      call_type: searchInput.call_type,
      status: searchInput.status
    };
    newSearchInput[fieldName] = e.target.value;
    setSearchInput(newSearchInput);
  };

  const changeLineValue = (e, type='', id='') => {
    let value = e.target.value;

    let targetId = (id === "" ? e.target.id : id);

    if(type === "number"){
      if(!/^[0-9*+]*$/.test(value)){
          setPhoneErrorText(t("The phone can only contain numbers"));
          return;
      }

      setPhoneErrorText("");
    }
    if(targetId === "active"){
      value = (e.target.checked ? 1 : 0);
    }
    let newFormInput = {
      title : lineFormInput.title,
      id : lineFormInput.id,
      number : lineFormInput.number,
      active: lineFormInput.active,
      note: lineFormInput.note,
      actionNote: lineFormInput.actionNote,
      action: lineFormInput.action,
      call_type: lineFormInput.call_type,
      status: lineFormInput.status
    };
    newFormInput[targetId] = value;
    setLineFormInput(newFormInput);
}

const displayDeletePopup = (lineData) => {
  setLineToDelete(lineData);
  setDeleteDialogIsOpen(true);
}

const displayEditPopup = (lineData) => {
  setLineFormInput(lineData);
  setDialogIsOpen(true);
}



const handleSwitchClick = (e) => {
  if(props.selectedLine.id === null && linesInCustomer.length > 0){
    props.setSelectedLine(linesInCustomer[0]);
  }else{
    props.setSelectedLine(initialLine);
  }
};

const handleSelectLine = (e) => {
  for(let index=0; index<linesInCustomer.length; index++){
    if(""+linesInCustomer[index].id === e.target.getAttribute("data-id")){
      props.setSelectedLine(linesInCustomer[index]);
    }
  }
}

const getLinesList = () => {
  let lines = [];

  lines.push(
    <div 
      className='line selected' 
      key={props.selectedLine.id}
      data-id={props.selectedLine.id}
      onClick={handleSelectLine}
      >
         <div className='text'>{props.selectedLine.use_name + " | " + props.selectedLine.number}</div>
        <div className='arrow arrow-up'></div>
    </div>
  );

  for (let index = 0; index < linesInCustomer.length; index++) {
    if(linesInCustomer[index].id === props.selectedLine.id){
      continue;
    }
    lines.push(
    <div 
      className='line' 
      key={linesInCustomer[index].id}
      data-id={linesInCustomer[index].id}
      onClick={handleSelectLine}
      >
      {linesInCustomer[index].use_name + " | " + linesInCustomer[index].number}
    </div>
    );
  }
  return lines;
}


  return (  
    <>
      {(
        props.isDesktop ? 
        <BlockCategoryDesktop 
          rows={rows}
          line={props.selectedLine}
          customer={selectedCustomer}
          isLinesListVisible={isLinesListVisible}
          setCustomerView={props.setCustomerView}
          rowCount={rowCount}
          loading={loading}
          page={page}
          pageSize={pageSize}
          setPage={setPage}
          setPageSize={setPageSize}
          handleAddRow={handleAddRow}
          setIsLinesListVisible={setIsLinesListVisible}
          changeSearchFilters={changeSearchFilters}
          handleEditBlockSubmit={handleEditBlockSubmit}
          displayDeletePopup={displayDeletePopup}
          handleDeleteRow={handleDeleteRow}
          displayEditPopup={displayEditPopup}
          expandedRowIds={expandedRowIds}
          setExpandedRowIds={setExpandedRowIds}
          />
           :
        <BlockCategoryMobile 
          rows={rows} 
          line={props.selectedLine}
          customer={selectedCustomer}
          isLinesListVisible={isLinesListVisible}
          setCustomerView={props.setCustomerView}
          rowCount={rowCount}
          loading={loading}
          page={page}
          pageSize={pageSize}
          setPage={setPage}
          setPageSize={setPageSize}
          handleAddRow={handleAddRow}
          setIsLinesListVisible={setIsLinesListVisible}
          changeSearchFilters={changeSearchFilters}
          handleEditBlockSubmit={handleEditBlockSubmit}
          displayDeletePopup={displayDeletePopup}
          handleDeleteRow={handleDeleteRow}
          displayEditPopup={displayEditPopup}
          expandedRowIds={expandedRowIds}
          setExpandedRowIds={setExpandedRowIds}
          handleSwitchClick={handleSwitchClick}
          getLinesList={getLinesList}
        />
      )}
      <Dialog open={dialogIsOpen} onClose={handleDialogClose} PaperProps={{ className: 'bl-dialog-paper' }}>
        <div className='bl-dialog'>
          <div className='bl-dialog-header'>
            <div className='bl-dialog-icon'>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
            </div>
            <h3 className='bl-dialog-title'>{t(lineFormInput.title)}</h3>
            <button className='bl-dialog-close' onClick={handleDialogClose}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>

          <div className='bl-dialog-body'>
            <div className='bl-field'>
              <label htmlFor="number">{t("Phone Number")}</label>
              <input
                id="number" type="text" className='bl-input' dir="ltr"
                autoFocus
                value={lineFormInput.number}
                disabled={lineFormInput.action === ACTION_EDIT}
                placeholder={t("Phone Number")}
                onChange={e => changeLineValue(e, 'number')}
              />
              {phoneErrorText !== "" && <div className='bl-field-error'>{phoneErrorText}</div>}
            </div>

            <BlockNumberNotes />

            <div className='bl-field-row'>
              <div className='bl-field'>
                <label htmlFor="status">{t("Status")}</label>
                <select id="status" value={lineFormInput.status} onChange={e => changeLineValue(e, '', 'status')}>
                  {(allowedBlockStatuses().includes(STATUS_BLOCKED) || lineFormInput.status === STATUS_BLOCKED) && <option value={STATUS_BLOCKED}>{t("Blocked")}</option>}
                  {(allowedBlockStatuses().includes(STATUS_OPEN) || lineFormInput.status === STATUS_OPEN) && <option value={STATUS_OPEN}>{t("Open")}</option>}
                </select>
              </div>
              <div className='bl-field'>
                <label htmlFor="call_type">{t("Call Type")}</label>
                <select id="call_type" value={lineFormInput.call_type} onChange={e => changeLineValue(e, '', 'call_type')}>
                  {(allowedBlockCallTypes().includes(CALL_TYPE_OUT) || lineFormInput.call_type === CALL_TYPE_OUT) && <option value={CALL_TYPE_OUT}>{t("Outgoing call")}</option>}
                  {(allowedBlockCallTypes().includes(CALL_TYPE_IN) || lineFormInput.call_type === CALL_TYPE_IN) && <option value={CALL_TYPE_IN}>{t("Incoming call")}</option>}
                  {(allowedBlockCallTypes().includes(CALL_TYPE_ALL) || lineFormInput.call_type === CALL_TYPE_ALL) && <option value={CALL_TYPE_ALL}>{t("Both")}</option>}
                </select>
              </div>
            </div>

            <div className='bl-field'>
              <label htmlFor="note">{t("Note")}</label>
              <input id="note" type="text" className='bl-input' value={lineFormInput.note} placeholder={t("Note")} onChange={e => changeLineValue(e)} />
            </div>

            <div className='bl-field'>
              <label htmlFor="actionNote">הערת ביצוע (אופציונלי)</label>
              <input id="actionNote" type="text" className='bl-input' value={lineFormInput.actionNote} placeholder="הסיבה לשינוי" onChange={e => changeLineValue(e)} />
            </div>

            <div className='bl-toggle-field' onClick={() => changeLineValue({ target: { id: 'active', checked: lineFormInput.active !== 1 } })}>
              <span>{t("Is Active")}</span>
              <button type='button' role='switch' aria-checked={lineFormInput.active === 1}
                className={'bl-switch' + (lineFormInput.active === 1 ? ' on' : '')}
                onClick={(e) => { e.stopPropagation(); changeLineValue({ target: { id: 'active', checked: lineFormInput.active !== 1 } }); }}>
                <span className='bl-switch-knob' />
              </button>
            </div>
          </div>

          <div className='bl-dialog-footer'>
            <button className='bl-dialog-cancel' onClick={handleDialogClose}>{t('Cancel')}</button>
            <button className='bl-dialog-submit' onClick={() => {
              if(lineFormInput.id !== null){
                handleEditBlockSubmit(lineFormInput);
              }else{
                handleAddBlockSubmit();
              }
            }}>{t('Submit')}</button>
          </div>

          <Backdrop
            sx={{ color: '#fff', position: 'absolute', borderRadius: '18px', zIndex: 5 }}
            open={dialogLoaderVisible}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </div>
      </Dialog>
      <Dialog open={deleteDialogIsOpen} onClose={handleDeleteDialogClose} 
        >
        <DialogContent>
          <div className='popup-content'>
            <div className='text'>{t("Do you want to delete the record?")}</div>
            <div className='bl-field' style={{ margin: '0 0 12px' }}>
              <label htmlFor="del-actionnote">הערת ביצוע (אופציונלי)</label>
              <input id="del-actionnote" type="text" className='bl-input' value={deleteActionNote} placeholder="הסיבה למחיקה" onChange={(e) => setDeleteActionNote(e.target.value)} />
            </div>
            <div className='controls'>
              <div className='proceed'
              onClick={() => {
                handleDeleteRow(lineToDelete);
                setLineToDelete(initialLine);
                handleDeleteDialogClose();
              }}
              >{t("Yes")}</div>
              <div className='cancel'
                onClick={handleDeleteDialogClose}
              >{t("Cancel")}</div>
            </div>
          </div>
        </DialogContent>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={dialogLoaderVisible}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
    </>
  );
}
